export const SectionTitle = ({ eyebrow, title, align = "left", children }) => {
  return (
    <div className={`${align === "center" ? "text-center mx-auto" : ""} max-w-3xl mb-10`}>
      {eyebrow && (
        <p className="text-xs md:text-sm tracking-[0.35em] uppercase text-terracotta font-medium mb-3">
          {eyebrow}
        </p>
      )}
      <h2 className="font-display text-4xl md:text-5xl lg:text-6xl font-black text-ink leading-[1.02]">
        {title}
      </h2>
      {children && <p className="text-muted_ink mt-5 text-base md:text-lg leading-relaxed">{children}</p>}
    </div>
  );
};

export default SectionTitle;
